/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useRef, useState } from 'react'
import AssistantChat from './AssistantChat.jsx'

export default function Fab() {
  const [open, setOpen] = useState(false)
  const root = useRef(null)

  useEffect(() => {
    const onDoc = (e) => {
      if (root.current && !e.composedPath().includes(root.current)) setOpen(false)
    }
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('click', onDoc)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('click', onDoc)
      document.removeEventListener('keydown', onKey)
    }
  }, [])

  return (
    <div className="seq-fab" id="seq-fab" dir="rtl" ref={root}>
      <div className={'seq-fab-panel' + (open ? ' is-open' : '')} id="seq-fab-panel" role="dialog" aria-label="پشتیبانی">
        <div className="seq-fab-head">
          <div className="seq-fab-prof">
            <span className="seq-fab-badge">
              <img src="a/bot-ico.webp" alt="" />
            </span>
            <h3 className="seq-fab-name">پشتیبانی</h3>
          </div>
          <button className="seq-fab-x" type="button" id="seq-fab-close" aria-label="بستن" onClick={() => setOpen(false)}>
            ✕
          </button>
        </div>
        <AssistantChat />
      </div>
      <button className="seq-fab-btn" type="button" id="seq-fab-open" aria-label="پشتیبانی" aria-haspopup="dialog" aria-expanded={open ? 'true' : 'false'} aria-controls="seq-fab-panel" onClick={() => setOpen((v) => !v)}>
        <img src="a/ico-assistant-bot-07ba722e.webp" alt="" width="96" height="90" />
      </button>
    </div>
  )
}
